



























































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { PolicyDto } from "@/api/ClientPortalApiClient";
import { Prop } from "vue-property-decorator";
import router, { ROUTES } from "@/router";

@Component
export default class PolicyCardPension extends Vue {
  @Prop(PolicyDto) readonly policyDetails: PolicyDto | undefined;
  @Prop() perform: number | undefined;

  openPolicyDetails() {
    if (this.policyDetails) {
      router.push({
        name: ROUTES.policyDetailsPension,
        params: { policyId: this.policyDetails.id.toString() }
      });
    }
  }
}
